import React from "react";
import { Badge, Link, Text, Tooltip } from "@merge-api/merge-javascript-shared";
import { Info } from "lucide-react";
import { BaseColor } from "@merge-api/merge-javascript-shared/dist/designSystem/types";
import {
  LinkedAccount,
  LinkedAccountStatus,
  PauseReason,
} from "../../../../../../../../../models/Entities";
import { BILLING_PATH } from "../../../../../../../../../router/RouterUtils";

interface Props {
  linkedAccount: LinkedAccount;
}

const IDLE_PAUSE_REASONS = [
  PauseReason.FAILING_SYNCS,
  PauseReason.LINKED_ACCOUNT_INACTIVITY,
  PauseReason.PRICING_PLAN_LIMIT,
];

const STATUS_DISPLAY: Record<string, { color: BaseColor; label: string }> = {
  [LinkedAccountStatus.COMPLETE]: { color: "green", label: "Linked" },
  [LinkedAccountStatus.INCOMPLETE]: { color: "orange", label: "Incomplete" },
  [LinkedAccountStatus.RELINK_NEEDED]: { color: "red", label: "Relink needed" },
  IDLE: { color: "gray", label: "Idle" },
};

const StatusBadge = ({ linkedAccount }: Props) => {
  if (linkedAccount.pause_reason === PauseReason.PLAN_LIMIT_REACHED) {
    return (
      <div className="flex flex-row items-center gap-2">
        <Text className="text-gray-40">Upgrade plan</Text>
        <Tooltip
          title={
            <>
              You can only connect 3 production and 3 test Linked Accounts on the Free plan.{" "}
              <span onClick={(event) => event.stopPropagation()}>
                <Link href={BILLING_PATH} className="underline text-white">
                  Upgrade your plan
                </Link>
              </span>{" "}
              to link more accounts.
            </>
          }
        >
          <Info className="text-gray-40" size={16} />
        </Tooltip>
      </div>
    );
  }

  const status = IDLE_PAUSE_REASONS.includes(linkedAccount.pause_reason as PauseReason)
    ? "IDLE"
    : linkedAccount.status;
  const display = STATUS_DISPLAY[status] ?? STATUS_DISPLAY[LinkedAccountStatus.COMPLETE];

  return (
    <Badge color={display.color} size="md" className="whitespace-nowrap">
      {display.label}
    </Badge>
  );
};

export default StatusBadge;
